<template>
  <div>
    <b-modal id="modalCericProposal"
             centered
             no-close-on-backdrop
             title="Proposal for CERIC"
             @hidden="resetModal"
             @show="resetModal">

      <ceric-manage-proposal-form :object-id="objectId"
                                  :save-button-handler="saveButtonHandler"
                                  :touch-validator="saveAttempt"
                                  @set-validation="handleValidityState($event)"
                                  @submission-state="handleSubmissionState($event)"/>

      <template #modal-footer>
        <button-spinner :loading="saveButtonHandler"
                        class="ma-2 right"
                        variant="info"
                        @click="handleOk">
          <template v-slot:defaultText>
            <span>Save proposal</span>
          </template>
          <template v-slot:spinnerText>
            <span> Saving...</span>
          </template>
        </button-spinner>
      </template>

    </b-modal>
  </div>
</template>

<script>
  import CericManageProposalForm from '@/components/proposal/ceric/CericManageProposalForm';
  import buttonSpinner from '@/components/buttonSpinner';

  export default {
    name: 'CericManageModal',
    components: {
      CericManageProposalForm,
      buttonSpinner,
    },
    props: {
      objectId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        validityState: null,
        saveAttempt: false,
        saveButtonHandler: false,
      };
    },
    methods: {
      handleValidityState(state) {
        this.validityState = state;
        return state;
      },
      resetModal() {
        this.validityState = null;
        this.saveAttempt = false;
        this.saveButtonHandler = false;
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault();
        // Trigger save handler
        this.handleSave();
      },
      handleSave() {
        this.saveAttempt = true;
        // Exit when the form isn't valid
        if (!this.validityState) {
          return;
        }
        this.saveButtonHandler = true;
      },
      handleSubmissionState(state) {
        if (state) {
          this.hideModalManually();
          this.$emit('refresh-dashboard');
        }
        this.saveButtonHandler = false;
      },
      hideModalManually() {
        this.$nextTick(() => {
          this.$bvModal.hide('modalCericProposal');
        });
      },
    },
  };
</script>

<style lang="scss" scoped>

</style>
